import Vue from 'vue';
import ElementUI from 'element-ui';
import i18n from '../i18n/index';

Vue.use(ElementUI, {
  i18n: (key: string, value: string) => i18n.t(key, value),
});
